module.exports = __webpack_public_path__ + "img/oohforce深色背景.008cb83b.png";